<template>
    <content-page page-name="APPPRIVACYPOLICY"></content-page>
</template>

<script>
import ContentPage from "../components/ContentPage";

export default {
    name: "privacy-policy",

    components: { ContentPage }
};
</script>
